module.exports = __webpack_public_path__ + "images/maskable_icon-128.9fd337c2a3624f54dabfcd6e98662435.png";